import Controller from '@ember/controller';
import { action } from '@ember/object';
import ICONS from 'sh-www/constants/assets/icons';

class UpgradeController extends Controller {
  /**
   * @type {String}   Path to submitted icon
   */
  _icon = ICONS.SUBMITTED;

  /**
   * @type {Boolean}      True if we have submitted the contact us form.
   */
  _shouldShowCompletionScreen = false;

  @action
  onContactSupportConfirmed() {
    this.set('_shouldShowCompletionScreen', true);
  }
}

export default UpgradeController;
